import script from "./CompanyAutocompleteForEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyAutocompleteForEvent.vue?vue&type=script&setup=true&lang=js"

import "./CompanyAutocompleteForEvent.vue?vue&type=style&index=0&id=9dd197a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd197a4"]])

export default __exports__